<template>
  <div class="pipeline_layout">
    <div class="flex pb-50">
      <slot name="filters"></slot>
    </div>

    <div
      :class="['pipeline_layout--content',
      {
        'is-board-style': isBoardStyle,
        'is-column-style': isColumnStyle,
      }]"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "PipelineLayout",
  props: {
    isBoardStyle: {
      type: Boolean,
      default: false
    },
    isColumnStyle: {
      type: Boolean,
      default: false
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.pipeline_layout {
  display: flex;
  flex-direction: column;
  height: 100%;

  &--content {
    //position: relative;
    flex-grow: 1;
    overflow-y: scroll;
    padding-right: $defaultGap;
    padding-bottom: 10px;

    &.is-board-style {
      overflow-y: hidden;
      overflow-x: scroll;
      padding: 0;
    }

    &.is-column-style {
      display: flex;
      overflow-y: hidden;
      padding-right: 0;
    }
  }
}
</style>
